/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Sample_SessionInputs */

const en_portal_sample_session = /** @type {(inputs: Portal_Sample_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1 session`)
};

const pl_portal_sample_session = /** @type {(inputs: Portal_Sample_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening 1:1`)
};

/**
* | output |
* | --- |
* | "1:1 session" |
*
* @param {Portal_Sample_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_sample_session = /** @type {((inputs?: Portal_Sample_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Sample_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_sample_session(inputs)
	return en_portal_sample_session(inputs)
});